//--------------------------
// is counters block action
//--------------------------
export default function isCountersBlockingAction(props, marker) {
  console.log('---------------------------------')
  console.log('isCountersBlockingAction')
  console.log('cnt = ' + props.row['counters'])

  if (marker) {
    console.log('marker = ' + marker.name)
  }
  //----------------
  // if no counters     [can proceed regardless as no markers currently]
  //----------------
  if (props.row['counters'] == 0) {
    console.log('iscounters1 - no EXISTING counters at all IGNORING whether new selection is a counter = false')
    return false
    //--------------------------------------------------
    // else must have counters - if new slot NOT marker    [blocking action as counters exist]
    //--------------------------------------------------
  } else if (!marker) {
    console.log('iscounters2 - must have EXISTING counters BUT new slot NOT marker = true')
    return true
    //------------------------------
    // else if new marker = counter     [can proceed as new marker is counter - will just need to check contiguous]
    //------------------------------
  } else if (marker.name == 'counter') {
    console.log('iscounters3 - must have EXISTING counters BUT new marker IS counter = false')
    return false
    //----------------
    // default - fail
    //----------------
  } else {
    console.log('iscounters4 - default = true')
    return true
  }
}
